import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {v4 as uuidv4} from 'uuid';
import {labels} from '../../../../../../util/utils';
import Button from '../../../../BaseComponentWrappers/MotifButton';
import AccountListItem from './AccountListItem';
import {getAccountsAllIds, getSliceById} from '../../../../../../selectors/Ares/selectors';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';

export default function AccountList(props) {
	const {assertions, risk, getBodiesBySectionId, isDisabled} = props;
	
	const accountIds = useSelector(getAccountsAllIds);
	const accountsById = useSelector((state) => getSliceById(state, 'accounts'));
	
	const [groupByAccount, setGroupByAccount] = useState([]);
	const [accountListOption, setAccountListOption] = useState([]);
	const [isAddAnAccountDisabled, setIsAddAnAccountDisabled] = useState(false);
	const [isAddAccountInProgress, setIsAddAccountInProgress] = useState(0);

	useEffect(() => {
		let formattedAccountList = accountIds.map((id) => {
			return {
				value: accountsById[id].id,
				label: accountsById[id].accountName,
				title: accountsById[id].accountName,
				typeId: accountsById[id].accountTypeId,
				statementTypeId: accountsById[id].statementTypeId
			};
		}, this);
		setAccountListOption(formattedAccountList);
	}, [accountIds]);

	useEffect(() => {
		if (assertions && assertions.length > 0) {
			setGroupByAccount(assertions);
		} else if (assertions?.length === 0) {
			//Display row with nothing selected if the risk does not have an assertion associated with it
			let newAccount = createNewAccountRow();

			setGroupByAccount([newAccount]);
		}
	}, [assertions]);

	useEffect(() => {
		let assertions = risk?.assertions;
		let notAvailableAccountsIds = assertions
			?.map((assertion) => assertion.account.id)
			?.filter((value, index, self) => self.indexOf(value) === index);

		// Filter accounts that have already been selected
		let availableAccounts = accountListOption.filter((account) => !notAvailableAccountsIds?.includes(account.value));

		const incompleteRows = groupByAccount.filter((accRow) => !accRow.assertionResults);

		//Disable Add an account button until all rows have been completed and there are pending accounts to relate
		setIsAddAnAccountDisabled(incompleteRows.length > 0 || availableAccounts.length === 0);
	}, [groupByAccount, isAddAccountInProgress]);

	const handlerOnAddAnAccount = () => {
		let newAccount = createNewAccountRow();

		setGroupByAccount((groupByAccount) => [...groupByAccount, newAccount]);
		setIsAddAccountInProgress(groupByAccount.length + 1);
	};

	const createNewAccountRow = () => {
		return {
			account: {
				key: 0,
				hash: uuidv4()
			},
			assertionResults: null
		};
	};

	return (
		<>
			{accountIds?.length > 0 && groupByAccount?.length > 0
				? groupByAccount.map((account) => (
						<AccountListItem
							key={account.account.hash}
							accountId={account.account.key === 0 ? account.account.hash : account.account.key}
							assertionProps={account.assertionResults}
							accounts={accountIds}
							accountListOption={accountListOption}
							risk={risk}
							accountHash={account.account.hash}
							getBodiesBySectionId={getBodiesBySectionId}
							isDisabled={isDisabled}
						/>
				  ))
				: null}
			<StyledAddAccountLink className="StyledAddAccountLink">
				<Button
					variant="text-alt"
					className="addaccount-link"
					onClick={handlerOnAddAnAccount}
					disabled={isAddAnAccountDisabled || isDisabled}
					showIcon
					iconSource={IconoirPlusCircle}
					showLabel
					buttonLabel={labels.addAnAccount}
					labelClassName="add-account-label"
				/>
			</StyledAddAccountLink>
		</>
	);
}

const StyledAddAccountLink = styled.section`
	.addaccount-link {
		.motif-icon svg {
			height: var(--px-15) !important;
			width: var(--px-15) !important;
		}
	}
`;
